<template>
    <q-card class="bg-white" :flat="page_feed">
        <q-card-title class="text-center bg-primary text-white" v-if="!page_feed">
            {{ $t(title_feed) }}
        </q-card-title>
        <q-card-separator v-if="!page_feed" />
        <q-card-main class="text-center relative-position" :style="home ? '' : 'min-height: 70vh'">
            <q-list no-border separator link>
                <q-item v-for="(activity, index) in filteredActivities" :key="index" class="q-py-lg q-px-none " @click.native="openActivity(activity)">
                    <q-item-side v-if="$q.platform.is.desktop && !home" class="image-activity-desktop">
                        <img :src="getImageUrl(activity.im)" v-if="activity.im" />
                        <img :src="getPlaceholder(activity)" v-if="!activity.im" />
                    </q-item-side>

                    <q-item-main label-lines="1" sublabel-lines="2">
                        <div class="text-center q-mb-sm" :class="activity.s == 'bu' ? 'image-activity-mobile-badge' : 'image-activity-mobile'" v-if="$q.platform.is.mobile || home">
                            <img :src="getImageUrl(activity.im)" v-if="activity.im" />
                            <img :src="getPlaceholder(activity)" v-if="!activity.im" />
                        </div>

                        <q-item-tile  class="text-faded q-mb-md" v-if="$q.platform.is.mobile">
                            <timeago :datetime="activity.d" :auto-update="60"></timeago>
                        </q-item-tile>

                        <div>
                            <span v-html="getActivityDescription(activity)" />
                        </div>

                        <q-item-tile  class="text-faded" v-if="$q.platform.is.desktop">
                            {{ getTimeAgo(activity.d) }}
                        </q-item-tile>
                    </q-item-main>
                </q-item>
            </q-list>

            <q-inner-loading :visible="timeline.length == 0">
                <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
            </q-inner-loading>
        </q-card-main>
    </q-card>
</template>

<script>
import { db } from 'plugins/vuefire'
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import * as moment from 'moment'

export default {
    props: ['home', 'page_feed', 'qtn_active'],

    i18nOptions: { namespaces: ['custom', 'common', 'feed'] },

    data() {
        return {
            timeline: [],
            selected_client_params: [],
            badges: [],
            locale: 'pt-br'
        }
    },

    computed: {
        ...mapGetters({
            id: 'common/id',
            access_token: 'common/access_token',
            user_firebase_document: 'common/user_firebase_document',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            languages: 'params/languages',
            id_user_language_selected: 'common/id_user_language_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        filteredActivities() {
            if (this.timeline) {
                let timeline = Object.assign([], this.timeline.ev)

                if (this.qtn_active) {
                    return timeline.slice(0, this.qtn_active)
                }
                else return timeline
            }
            else return []
        },

        title_feed() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_feed == '' ? 'feed' : obj.title_feed
				}
			}
        },
    },

    methods: {
        getBadges() {
            this.$axios.get(`/etraining_badges/badges/`, this.getHeader)
            .then(response => {
                this.badges = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },

        getBadgeTitle(id) {
            if (this.badges.length > 0) {
                let obj = this.badges.find((obj) => { return obj.id === id })
                if (obj) {
                    let lang = obj.badge_languages.find((l) => { return l.language === this.id_user_language_selected })
                    if (lang) return lang.title
                }
            }
            return ''
        },

        getActivityDescription(activity) {
            switch(activity.s){
                case 'gtp': return `${this.$t('the_training')} <span class='text-secondary text-bold'>${activity.p.t}</span> ${this.$t('was_published')}.`
                break
                case 'gtur': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('earned_a_certification_on_the_training')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`
                break
                case 'gtul': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('liked_the_training')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`
                break
                case 'gtus': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('evaluated_the_training')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`
                break
                case 'gtuf': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('favorited_the_training')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`


                case 'ppp': return `${this.$t('the_podcast')} <span class='text-secondary text-bold'>${activity.p.t}</span> ${this.$t('was_published')}.`
                break
                case 'ppul': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('liked_the_podcast')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`
                break
                case 'ppus': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('evaluated_the_podcast')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`
                break
                case 'ppuf': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('favorited_the_podcast')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`


                break
                case 'tp': return `${this.$t('the_trail')} <span class='text-secondary text-bold'>${activity.p.t}</span> ${this.$t('was_published_f')}.`
                break
                case 'tur': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('earned_a_certification_on_the_trail')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`
                break
                case 'tul': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('liked_the_trail')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`
                break
                case 'tus': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('evaluated_the_trail')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`
                break
                case 'tuf': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('favorited_the_trail')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`
                case 'lfp': return `${this.$t('the_file')} <span class='text-secondary text-bold text-underline'>${activity.p.t}</span> ${this.$t('was_published_on_the_library')}.`
                break
                case 'bu': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('earned_the_badge')} <span class='text-secondary text-bold'>${this.getBadgeTitle(activity.i)}</span>.`
                case 'wcp': return `${this.$t('the_webcast')} <span class='text-secondary text-bold'>${activity.p.t}</span> ${this.$t('was_published')}.`
                case 'nc': return `<span class='text-secondary text-bold text-underline'>${activity.p.n}</span> ${this.$t('commented_the_news')} <span class='text-secondary text-bold'>${activity.p.t}</span>.`
                break
            }
        },

        getImageUrl(image) {
            return process.env.BUCKET_URL + image
        },

        getPlaceholder(activity) {
            switch(activity.s){
                case 'gtp':
                case 'gtur':
                case 'gtul':
                case 'gtuf':
                case 'bu':
                case 'gtus': return this.selected_client_params.group_training_placeholder
                break
                case 'ppul':
                case 'ppuf':
                case 'ppus': return this.selected_client_params.podcast_placeholder
                break
                case 'tp':
                case 'tur':
                case 'tul':
                case 'tuf':
                case 'tus': return this.selected_client_params.group_training_placeholder
                break
                case 'lfp': return this.selected_client_params.group_library_file_placeholder
                break
                case 'nc': return this.selected_client_params.news_placeholder
                break
            }
        },

        openActivity(activity) {
            switch(activity.s) {
                case 'gtp':
                case 'gtur':
                case 'gtul':
                case 'gtus':
                case 'gtuf': this.$router.push({ name: 'course', params: { id: activity.i } })
                break
                case 'tp':
                case 'tur':
                case 'tul':
                case 'tus':
                case 'tuf': this.$router.push({ name: 'trail', params: { id: activity.i } })
                break
                case 'lfp': this.$router.push({ name: 'library', params: { id_file: activity.i } })
                break
                case 'wcp': this.$router.push({ name: 'webcasts' })
                break
                case 'nc': this.$router.push({ name: 'news' })
                break
            }
        },

        getDate(date_raw) {
            var newDate = date.subtractFromDate(date_raw, { minutes: 120 })
            return newDate
        },

        getTimeAgo(d) {
            if (typeof d !== 'string') {
                const time = d.toDate()
                return moment(time).locale(this.locale).fromNow()
            } else return moment(d).locale(this.locale).fromNow()
        },

        setLocale() {
            let language = this.languages.find(l => {
                return l.id === this.id_user_language_selected
            })

			if (language) {
				this.locale = language.code
            }
        }
    },

    watch: {
        user_firebase_document: {
            handler: function(newValue) {
                if (this.user_firebase_document) {
                    this.$unbind('timeline')
                    this.timeline = []

                    this.$bind('timeline', db.collection('timeline').doc(`${this.user_firebase_document}`)).then(timeline => {
                        this.timeline === timeline
                    })
                }
            },
            deep: true
        },

        id_user_language_selected: function(val) {
            this.setLocale()
        }
    },

    created() {
        /*
            Slugs
            gtp - Treinamento publicado
                t - Título
            gtur - Usuário certificado treinamento
                n - Nome do usuário
                t - Título
            gtul - Like em treinamento
                n - Nome do usuário
                t - Título
            gtus - Avaliação em treinamento
                n - Nome do usuário
                t - Título
            gtuf - Treinamento Favoritado
                n - Nome do usuário
                t - Título
            tp - Trilha publicada
                t - Título
            tur - Usuário certificado trilha
                n - Nome do usuário
                t - Título
            tul - Like em trilha
                n - Nome do usuário
                t - Título
            tus - Avaliação em trilha
                n - Nome do usuário
                t - Título
            tuf - Trilha Favoritada
                n - Nome do usuário
                t - Título
            lfp - Arquivo publicado na biblioteca
                t - Título

        */

       this.getBadges()

        this.$bind('timeline', db.collection('timeline').doc(`${this.user_firebase_document}`)).then(timeline => {
            this.timeline === timeline
        })

        this.selected_client_params = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

        this.setLocale()
    }
}
</script>

<style lang="stylus" scoped>
.image-activity-mobile-badge
    & img
        width 60%
        height auto

.image-activity-mobile
    & img
        width 100%
        height auto

.image-activity-desktop
    min-width 90px
    & img
        width auto
        height 50px
</style>
